import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/teachQuality/page',
    add:'/api-ir/bachelor/teachQuality/add',
    update:'/api-ir/bachelor/teachQuality/edit',
    info:'/api-ir/bachelor/teachQuality/info/',
    del:'/api-ir/bachelor/teachQuality/delete/',
    lastUpdateTime:'/api-ir/bachelor/teachQuality/lastUpdateTime',
    export:'/api-ir/bachelor/teachQuality/export/',
    books:'/api-ir/bachelor/textbook/info'
}
// 查询课程列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询课程信息
export function classroomInfo (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除课程
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 最后更新时间
export function lastUpdateTime () {
    return baseAPI.axiosData(api.lastUpdateTime,'get')
}

export function exportFile (id) {
    return baseAPI.axiosData(api.export+id,'get')
}

export function books (data) {
    return baseAPI.axiosData(api.books,'post',data)
}